/* Comforts Kids post-interaction loader for Microsoft Clarity and Judge.me (PERF-03, D-16). */
(function () {
  'use strict';

  var cfg = null;
  try {
    var el = document.getElementById('ck-defer-config');
    if (el) cfg = JSON.parse(el.textContent);
  } catch (e) {
    cfg = null;
  }

  var done = false;
  var timer = 0;
  var EVENTS = ['pointerdown', 'keydown'];
  var scrollArmed = false;

  /* A restored scroll position or a /#designs jump fires scroll while the page is still loading; that is
     not the visitor's interaction, and loading Clarity/Judge.me then would compete with the hero photo.
     Scroll counts from the first frame after the load event (the photo has loaded by then). */
  function armScroll() {
    requestAnimationFrame(function () {
      setTimeout(function () {
        scrollArmed = true;
      }, 0);
    });
  }

  function onScroll() {
    if (scrollArmed) run();
  }

  function isValidClarityId(id) {
    return typeof id === 'string' && /^[a-z0-9]{6,20}$/i.test(id);
  }

  function isAllowedReviewsSrc(url) {
    if (typeof url !== 'string' || !url) return false;
    try {
      var u = new URL(url);
      return u.protocol === 'https:' && (u.hostname === 'judge.me' || /\.judge\.me$/.test(u.hostname));
    } catch (e) {
      return false;
    }
  }

  function addScript(src) {
    var s = document.createElement('script');
    s.async = true;
    s.src = src;
    document.head.appendChild(s);
  }

  function run() {
    if (done) return;
    done = true;
    clearTimeout(timer);
    EVENTS.forEach(function (name) {
      window.removeEventListener(name, run, true);
    });
    window.removeEventListener('scroll', onScroll, true);
    if (!cfg) return;
    if (isValidClarityId(cfg.clarityId)) {
      window.clarity =
        window.clarity ||
        function () {
          (window.clarity.q = window.clarity.q || []).push(arguments);
        };
      addScript('https://www.clarity.ms/tag/' + encodeURIComponent(cfg.clarityId));
    }
    if (isAllowedReviewsSrc(cfg.reviewsSrc)) {
      addScript(cfg.reviewsSrc);
    }
  }

  window.CKDefer = { isValidClarityId: isValidClarityId, isAllowedReviewsSrc: isAllowedReviewsSrc, run: run };

  if (!cfg) return;
  EVENTS.forEach(function (name) {
    window.addEventListener(name, run, { capture: true, passive: true, once: true });
  });
  window.addEventListener('scroll', onScroll, { capture: true, passive: true });
  if (document.readyState === 'complete') armScroll();
  else window.addEventListener('load', armScroll, { once: true });
  timer = setTimeout(run, 5000);
})();
